import React, { useId, useMemo } from 'react';
import InputError from '../InputError/InputError';
import InputLabel from '../InputLabel/InputLabel';
import SelectField from '../SelectField/SelectField';
import { MONTH_NUMBERS } from 'constants/date';
import { getMaxDayForMonth } from 'utils/date';

export default function MonthDayField({
  label,
  month = null,
  day = null,
  onChange,
  error,
  loading = false,
  disabled = false,
  className = '',
}) {
  const fieldId = useId();
  const monthOptions = useMemo(() => MONTH_NUMBERS.map((value) => ({
    value,
    label: new Intl.DateTimeFormat(undefined, {
      month: 'short',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(2024, value - 1, 1))),
  })), []);

  const dayOptions = useMemo(() => {
    const maxDay = getMaxDayForMonth(month);

    return Array.from({ length: maxDay }, (_, index) => ({
      value: index + 1,
      label: `${index + 1}`,
    }));
  }, [month]);

  const handleMonthChange = (nextMonth) => {
    const maxDay = getMaxDayForMonth(nextMonth);
    const nextDay = day == null ? null : Math.min(day, maxDay);

    onChange({ month: nextMonth, day: nextDay });
  };

  const handleDayChange = (nextDay) => {
    onChange({ month, day: nextDay });
  };

  return (
    <div className={className}>
      {label && <InputLabel className="mb-2">{label}</InputLabel>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <SelectField
          label="Month"
          name={`${fieldId}-month`}
          options={monthOptions}
          value={month}
          onChange={handleMonthChange}
          placeholder="Select month"
          loading={loading}
          disabled={disabled}
        />
        <SelectField
          label="Day"
          name={`${fieldId}-day`}
          options={dayOptions}
          value={day}
          onChange={handleDayChange}
          placeholder="Select day"
          loading={loading}
          disabled={disabled}
        />
      </div>
      {error && <InputError className="mt-2">{error}</InputError>}
    </div>
  );
}
